/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["kt-base{opacity:0;height:100%}kt-base .kt-grid--root{height:100%}.kt-page--loaded kt-base{opacity:1;-webkit-transition:opacity 1s ease-in-out;transition:opacity 1s ease-in-out}"];
export { styles as styles };
